import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  CardActions,
  Tooltip,
  Paper,
  Grid,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  getDocumentosDeUsuario,
  updateDocumentosDeUsuario,
} from "../services/usuarios.service";
import { obtenerDocumento } from "../services/uploadFile.service";
import { COLORS } from "../config/theme";
import UploadFilesModal from "./UploadFilesModal";
import ButtonComponent from "./ButtonComponent";
import Modal from "./Modal";

const DocumentosDeUsuario = ({ idUsuario, setReload, reload }) => {
  const [documentos, setDocumentos] = useState([]);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);
  const [modalWidth, setModalWidth] = useState("500px");
  const [fetchDocuments, setFetchDocuments] = useState(false);
  const [reloadDocuments, setReloadDocuments] = useState(false);

  const abrirDocumento = async (key) => {
    try {
      const response = await obtenerDocumento(key);

      if (response) {
        const signedUrl = response.url;
        const resultURL = signedUrl.split("?");

        window.open(resultURL[0], "_blank");
      } else {
        console.error("Error obteniendo documento");
      }
    } catch (error) {
      console.error("Failed to get signed URL", error);
    }
  };

  const handleFileUploadFinish = async (uploadedFiles) => {
    const uploaded = await updateDocumentosDeUsuario(
      idUsuario.id_usuario,
      uploadedFiles
    );
    setReloadDocuments(!reloadDocuments);
    setIsVisibleModal(false);
    if (uploaded) {
      setFetchDocuments(!fetchDocuments);
    }
  };

  const agregarDocumento = () => {
    setModalTitle("SUBIR ARCHIVOS");
    setModalContent(
      <UploadFilesModal
        callback={handleFileUploadFinish}
        setIsVisibleModal={setIsVisibleModal}
        setReloadDocuments={setReloadDocuments}
        reloadDocuments={reloadDocuments}
      />
    );
    setIsVisibleModal(true);
  };

  const fetchDocumentos = async (idUser) => {
    try {
      const result = await getDocumentosDeUsuario(idUser);
      if (result.data) {
        console.log("documentos del usuario", result.data);
        Array.isArray(result.data)
          ? setDocumentos(result.data)
          : setDocumentos([result.data]);
      } else {
        setDocumentos([]);
      }
    } catch (error) {
      console.error("Error al obtener documentos:", error);
    }
  };
  useEffect(() => {
    if (idUsuario) {
      fetchDocumentos(idUsuario.id_usuario);
    } else {
      setDocumentos([]);
    }
  }, [idUsuario, fetchDocuments, reloadDocuments]);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Grid container>
          <Grid item xs={11}></Grid>
          <Grid item xs={1}>
            <Tooltip title="Agregar documento">
              <Button
                type="primary"
                onClick={agregarDocumento}
                style={{
                  backgroundColor: COLORS ? COLORS.SECONDARY : "#00909E",
                  color: "#fff",
                }}
              >
                <PlusOutlined />
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
      </div>
      <Paper
        elevation={3}
        style={{
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          height: "45vh",
          width: "100%",
          boxSizing: "border-box",
          overflowY: "scroll",
        }}
      >
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          {documentos.map((documento, index) => (
            <Card
              key={index}
              style={{
                width: "300px",
                backgroundColor: COLORS.LIGHT,
                textAlign: "center",
                cursor: "pointer",
              }}
              onClick={() => abrirDocumento(documento.url)}
            >
              <CardContent>
                <Typography variant="h6" component="div">
                  {documento.nombre}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Creado {new Date(documento.fecha_alta).toLocaleDateString()}
                </Typography>
              </CardContent>
              <CardActions style={{ justifyContent: "center" }}>
                <IconButton color="primary">
                  <DownloadIcon />
                </IconButton>
              </CardActions>
            </Card>
          ))}
        </div>
      </Paper>
      <Modal
        title={modalTitle}
        open={isVisibleModal}
        setIsVisible={setIsVisibleModal}
        width={modalWidth}
      >
        {modalContent}
      </Modal>
    </div>
  );
};

export default DocumentosDeUsuario;
